// extracted by mini-css-extract-plugin
export default {"email":"Contact_email__i+TZc","message":"Contact_message__6nyPH","formRow":"Contact_formRow__vw-Z5"};